/** One-shot camera barcode scan: resolves with the scanned text, or null if cancelled / unavailable. */
import { BarcodeFormat, DecodeHintType } from '@zxing/library';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { qs } from './dom.js';

const HINTS = new Map<DecodeHintType, unknown>([
  [DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E, BarcodeFormat.CODE_128, BarcodeFormat.CODE_39, BarcodeFormat.QR_CODE]],
]);

export function scanWithCamera(): Promise<string | null> {
  return new Promise((resolve) => {
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop';
    if (!navigator.mediaDevices?.getUserMedia) {
      backdrop.innerHTML = `<div class="modal"><h2>Camera scanning unavailable</h2><p>This browser can't use the camera. Use the handheld scanner or type the label in.</p><button class="ghost" id="closeBtn">Close</button></div>`;
      document.body.appendChild(backdrop);
      qs<HTMLButtonElement>(backdrop, '#closeBtn').addEventListener('click', () => {
        backdrop.remove();
        resolve(null);
      });
      return;
    }
    backdrop.innerHTML = `<div class="modal camera-modal"><h2>Scan with Camera</h2><p class="hint" id="cameraStatus">Starting camera…</p><video id="cameraVideo" autoplay playsinline muted></video><button class="ghost" id="cancelCamera" style="margin-top:0.75rem;">Cancel</button></div>`;
    document.body.appendChild(backdrop);
    const video = qs<HTMLVideoElement>(backdrop, '#cameraVideo');
    const statusEl = qs<HTMLParagraphElement>(backdrop, '#cameraStatus');
    let controls: { stop: () => void } | null = null;
    let done = false;
    const finish = (value: string | null): void => {
      if (done) return;
      done = true;
      controls?.stop();
      backdrop.remove();
      resolve(value);
    };
    qs<HTMLButtonElement>(backdrop, '#cancelCamera').addEventListener('click', () => finish(null));
    void (async () => {
      try {
        controls = await new BrowserMultiFormatReader(HINTS).decodeFromConstraints({ video: { facingMode: 'environment' } }, video, (result) => {
          if (result) finish(result.getText());
        });
        if (done) controls.stop();
        else statusEl.textContent = 'Point the camera at the label.';
      } catch {
        statusEl.classList.add('error-text');
        statusEl.textContent = "Couldn't access the camera. Check permissions and try again.";
      }
    })();
  });
}
